/**
 * Minimal encryption utility for sensitive data storage
 * Uses crypto-js to encrypt user data before storing in localStorage
 */

import CryptoJS from 'crypto-js';

// Encryption key derived from Cognito Client ID (already unique per environment)
const getEncryptionKey = (): string => {
  const clientId = process.env.REACT_APP_COGNITO_CLIENT_ID || '';
  const region = process.env.REACT_APP_COGNITO_REGION || '';
  // Combine multiple environment-specific values to create a unique key
  return CryptoJS.SHA256(`${clientId}-${region}-nbms-secure`).toString();
};

/**
 * Encrypts sensitive data (like user information)
 */
export const encryptData = (data: string): string => {
  const encrypted = CryptoJS.AES.encrypt(data, getEncryptionKey()).toString();
  return encrypted;
};

/**
 * Decrypts sensitive data
 */
export const decryptData = (encryptedData: string): string | null => {
  try {
    const bytes = CryptoJS.AES.decrypt(encryptedData, getEncryptionKey());
    const decrypted = bytes.toString(CryptoJS.enc.Utf8);
    return decrypted || null;
  } catch {
    return null;
  }
};
